import { createRouterSelector } from '@atlassian/react-resource-router';
import { useMatch } from './useMatch.tsx';
import { useQuery } from './useQuery.tsx';

export function useGetCurrentUrl(): string {
	const match = useMatch();
	const query = useQuery();

	const searchParams = new URLSearchParams(query ?? {});
	const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
	return url.toString();
}

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useGetCurrentUrlPath: (args_0: void) => string = createRouterSelector(
	(routerContext) => {
		const url = new URL(`http://example.com${routerContext.match.url}`);
		return url.toString();
	},
);
